import { DIALOG_WIDTH as o, VIEW_HEIGHT as i } from "./dimensions.mjs";
import e from "./styled.mjs";
const m = e("div")({
  overflow: "hidden",
  width: o,
  maxHeight: i,
  display: "flex",
  flexDirection: "column",
  margin: "0 auto"
});
export {
  m as PickerViewRoot
};
//# sourceMappingURL=PickerViewRoot.mjs.map
